/**
 * FIXME: This is putting logic on the frontend which isn't good,
 * we need to move this to the CMS.
 */
export function getIsProductPortraitImage(productCode: string) {
    return ['AP69'].includes(productCode)
}
